module.exports = __webpack_public_path__ + "img/MG-HIW-title.0991ebef.png";